import { useOffline, offlineStatus } from './';
import { classNames } from '../../Services/helpers';
import Errors from './Errors';

const Status = ({className}) => {
    const {status, sync, errorsOpen, setErrorsOpen} = useOffline();

    if (!status) {
        return null;
    }

    const classes = {
        [offlineStatus.PENDING]: 'bg-brand text-white',
        [offlineStatus.SYNCING]: 'bg-brand text-white',
        [offlineStatus.ERROR]: 'bg-red-500 text-white',
        [offlineStatus.COMPLETE]: 'bg-green-500 text-white',
        [offlineStatus.OFFLINE]: 'bg-gray-500 text-white',
    }

    const message = {
        [offlineStatus.PENDING]: 'Offline changes pending.',
        [offlineStatus.SYNCING]: 'Syncing offline changes...',
        [offlineStatus.ERROR]: 'There was an error syncing offline changes. More info.',
        [offlineStatus.COMPLETE]: 'Sync complete.',
        [offlineStatus.OFFLINE]: 'You are offline. Data may be out of date and changes may not be saved.',
    }

    const onClicks = {
        [offlineStatus.PENDING]: sync,
        [offlineStatus.SYNCING]: null,
        [offlineStatus.ERROR]: () => setErrorsOpen(true),
        [offlineStatus.COMPLETE]: null,
        [offlineStatus.OFFLINE]: sync,
    }

    return <div className={classNames(className, classes[status] ?? 'bg-gray-500 text-white')}
        onClick={onClicks[status]}
    >
        {message[status]}
        <Errors isOpen={errorsOpen} onClose={() => setErrorsOpen(false)} />
    </div>
}

export default Status;
